/*
 * (c) Copyright, 2024, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import { setLocale, object, array, string, date } from 'yup'

const ValidationSchema = () => {
  setLocale({
    mixed: {
      required: 'GENERAL_FORM_FIELD_IS_REQUIRED_ERROR'
    },
    string: {
      max: 'FORM_VALIDATION_ERROR_MAX_LENGTH_IS_${max}'
    }
  })

  return object().shape({
    notification: object().shape({
      merged: array()
        .default(() => [])
        .min(1, 'GENERAL_FORM_FIELD_IS_REQUIRED_ERROR')
        .required(),
      subject: string()
        .trim()
        .max(500)
        .required()
        .default(() => ''),
      expiration: date()
        .nullable()
        .default(() => null)
        .when('setExpiration', {
          is: true,
          then: (schema: unknown) => (schema as any).required()
        })
    })
  })
}

export default ValidationSchema
